import { Slot } from '../../../../features/calendar/components/time-block/calculation/geometry/slot/slot';
import { ITimeBlockComponentItem } from '../../../../features/calendar/components/time-block/types/time-block-component-item-types';
import { TimeBlockIntersectionService } from '../../../../features/calendar/components/time-block/calculation/intersection/time-block-intersection.service';
import { Injectable } from '@angular/core';
import { IFixIntervalViewType } from '../../../../features/calendar/components/time-block/types/time-block-types';

@Injectable({ providedIn: 'root' })
export class SlotHandlerService {
  public orderVariableIntervalTimeBlocksByStartDate(
    timeBlocksPerDay: ITimeBlockComponentItem[],
  ): void {
    timeBlocksPerDay.sort((first: ITimeBlockComponentItem, second: ITimeBlockComponentItem) => {
      const timeDifference =
        first.timeBlockModel.start.getTime() - second.timeBlockModel.start.getTime();
      if (timeDifference === 0) {
        const lengthFirst =
          first.timeBlockModel.end.getTime() - first.timeBlockModel.start.getTime();
        const lengthSecond =
          second.timeBlockModel.end.getTime() - second.timeBlockModel.start.getTime();
        return lengthSecond - lengthFirst;
      }
      return timeDifference;
    });
  }

  public orderFixIntervalTimeBlocks(timeBlocksPerDay: ITimeBlockComponentItem[]): void {
    // 1. sort by longest
    // 2. if tie, sort by created date
    timeBlocksPerDay.sort((first: ITimeBlockComponentItem, second: ITimeBlockComponentItem) => {
      const timespanFirst =
        first.timeBlockModel.end.getTime() - first.timeBlockModel.start.getTime();
      const timespanSecond =
        second.timeBlockModel.end.getTime() - first.timeBlockModel.start.getTime();
      const timeDifference = timespanSecond - timespanFirst;
      if (timeDifference === 0) {
        return first.timeBlockModel.start.getTime() - second.timeBlockModel.start.getTime();
      }
      return timeDifference;
    });
  }

  public updateGeometryHorizontalSlots(slots: Slot[]): ITimeBlockComponentItem[] {
    const updatedTimeBlocks = new Array<ITimeBlockComponentItem>();
    for (let slotIndex = 0; slotIndex < slots.length; slotIndex++) {
      const slot = slots[slotIndex];
      for (const timeBlock of slot.timeBlocks) {
        const timeBlockViewType = timeBlock.timeBlockModel
          .timeBlockViewType as IFixIntervalViewType;
        timeBlockViewType.parallelIndex = slotIndex;
        updatedTimeBlocks.push(timeBlock);
      }
    }
    return updatedTimeBlocks;
  }

  public assignTimeBlockToSlot(
    timeBlock: ITimeBlockComponentItem,
    slots: Slot[],
    intersectionService: TimeBlockIntersectionService,
    isDayIntersection: boolean,
  ): void {
    for (const slot of slots) {
      if (
        (isDayIntersection && !slot.intersectsTimeBlockDay(timeBlock)) ||
        (!isDayIntersection && !slot.intersectsTimeBlock(timeBlock))
      ) {
        slot.insert(timeBlock);
        return;
      }
    }
    slots.push(new Slot(intersectionService));
    slots[slots.length - 1].insert(timeBlock);
  }
}
